import { render, staticRenderFns } from "./customModal.vue?vue&type=template&id=06aabea4"
import script from "./customModal.vue?vue&type=script&lang=js"
export * from "./customModal.vue?vue&type=script&lang=js"
import style0 from "./customModal.vue?vue&type=style&index=0&id=06aabea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports